// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"fdf901e1","281":"2381c66f","508":"ae5a17a7"}[chunkId] + ".chunk.css";
};